var React = require('react');

function OkBtn (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M 130.5313,51.15864 72.2559,12.28364 C 64.9648,7.4193397 59,10.58534 59,19.31684 v 13.6821 H 20 c -5.5,0 -10,4.5015 -10,10.0015 v 34.0005 c 0,5.5 4.5,9.998 10,9.998 h 39 v 13.6855 c 0,8.7305 5.9648,11.8965 13.2559,7.0332 l 58.2754,-38.875 c 7.291,-4.8632 7.291,-12.8207 0,-17.684 z","id":"path89"}));
}

OkBtn.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"146","height":"120.001","viewBox":"0 0 146 120.001","enableBackground":"new 0 0 126 100.001","preserveAspectRatio":"xMidYMid meet","xmlSpace":"preserve"};

module.exports = OkBtn;

OkBtn.default = OkBtn;
